import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import { outlinedButtonClasses } from '../Button';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  subtitle?: string;
  selected?: boolean;
}

const RectangleButtonMulti = (props: Props): JSX.Element => {
  const { className, selected, onClick, subtitle, title, ...rest } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    // order matters for the classes
    <div className='relative'>
      {selected && (
        <div className='absolute -right-2 -top-2 rounded-xl bg-sapphire w-[25px] h-[25px]'>
          <FontAwesomeIcon
            icon={faCheck}
            className='text-white font-bold self-center ml-[2px] mt-[4px]'
          />
        </div>
      )}
      <button
        type='button'
        className={'transition-all border-2 border-sapphire-50 bg-white cursor-pointer duration-500 rounded-xl h-20 w-full '
          + `${outlinedButtonClasses}${selected ? ' text-sapphire !border-sapphire' : ''}${className ? ` ${className}` : ''}`}
        onClick={handleClick}
        aria-label={`${title}${subtitle ? ` ${subtitle}` : ''}`}
        {...rest}
      >
        {title && title?.length > 0 && (
          <div className='font-medium text-lg self-center pb-1'>
            {title}
          </div>
        )}
        {subtitle && subtitle?.length > 0 && (
          <div className='text-center font-medium text-xs'>
            {subtitle}
          </div>
        )}
      </button>
    </div>
  );
};

export { RectangleButtonMulti };
